<template>
  <div class="personal-info-page">
    <div class="info-wrapper">
      <div class="info-item">
        <div class="item-label">头像</div>
        <div class="item-right">
          <van-uploader
            ref="photoUploader"
            class="user-photo"
            result-type="dataUrl"
            v-model="faceImgs"
            max-count="2"
            :after-read="changeUserPhoto"
          />
          <span class="item-icon" @click="userPhotoChooseFile"
            ><van-icon name="arrow" size="16"
          /></span>
        </div>
      </div>
      <div class="info-item">
        <div class="item-label">姓名</div>
        <div
          class="item-right"
          @click="
            $router.push({
              path: '/personalInfoEdit',
              query: { propName: 'name', val: userInfo.name || '' },
            })
          "
        >
          <span class="item-value">{{ userInfo.name ? userInfo.name : '未设置' }}</span>
          <span class="item-icon"><van-icon name="arrow" size="16" /></span>
        </div>
      </div>
      <div class="info-item">
        <div class="item-label">性别</div>
        <div class="item-right" @click="genderPickerShow = true">
          <span class="item-value">{{
            userInfo.sex === 2 ? '未知' : userInfo.sex === 1 ? '男' : '女'
          }}</span>
          <span class="item-icon"><van-icon name="arrow" size="16" /></span>
        </div>
      </div>
      <div class="info-item">
        <div class="item-label">手机号</div>
        <!-- <div 
						class="item-right"
						@click="$router.push({
							path:'/personalInfoEdit', 
							query:{ propName: 'phone','val': userInfo.phone || ''}})"> -->
        <div class="item-right">
          <span class="item-value">{{ userInfo.phone ? userInfo.phone : '未绑定手机号' }}</span>
          <span class="item-icon">
            <!-- <van-icon name="arrow" size="16"/> -->
          </span>
        </div>
      </div>
    </div>
    <!-- <div class="student-info" @click="toStudentManagement">
      <div class="item-label">我的报名信息</div>
      <div class="item-right">
        <span class="item-icon"><van-icon name="arrow" size="16"/></span>
      </div>
    </div> -->
    <div class="switch-user" @click="switchUser">退出登录</div>
    <van-popup
      :value="genderPickerShow"
      position="bottom"
      @click-overlay="genderPickerShow = false"
    >
      <van-picker
        :value-key="'name'"
        :columns="genderPickerColumns"
        :show-toolbar="true"
        @confirm="genderPickerConfirm"
        :default-index="userInfo.sex === 1 ? 1 : 0"
        @cancel="genderPickerShow = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { detectFileType } from '@mlib/js/tool/file-detect.js';

export default {
  data() {
    return {
      pageTitle: '个人信息',
      faceImgs: [],
      genderPickerColumns: [
        { name: '女', id: 0 },
        { name: '男', id: 1 },
      ],
      genderPickerShow: false,
    };
  },
  created() {
    this.$onBus('personalInfoChangeName', v => {
      this.changeParentInfos('name', v);
    });
    this.$onBus('personalInfoChangePhone', v => {
      this.changeParentInfos('phone', v);
    });
  },
  computed: {
    ...Vuex.mapState(['userInfo']),
  },
  methods: {
    ...Vuex.mapMutations(['updataUserInfo']),
    async switchUser() {
      await vant.Dialog.alert({
        message: '确认要退出吗？',
        confirmButtonText: '退出',
        showCancelButton: true,
      });
      app.parent.switchUser();
    },
    // toStudentManagement() {
    //   this.$router.push("/studentManagement");
    // },
    userPhotoChooseFile() {
      this.$refs.photoUploader.chooseFile();
    },
    async changeUserPhoto(res) {
      // 这行避免修改图片后，图片预览的显示两张图片
      // 同时避免未裁剪确认就已经替换图片
      this.faceImgs.splice(this.faceImgs.length - 1);
      
      // 检测文件类型（只支持图片）
      let file = res.file;
      const result = await detectFileType(file, 'image');
      const { isImage, errorMsg, correctedFile } = result;
      const _suggestedName = correctedFile._suggestedName;
      
      // 如果检测失败或不是图片
      if (errorMsg || !isImage) {
        const fileExtension = file.name.split('.').pop();
        const suffix = fileExtension && fileExtension !== file.name ? `.${fileExtension}` : '无后缀';
        vant.Toast(`${suffix} - ${errorMsg || '文件格式不正确'}`);
        return;
      }
      
      // 如果需要修复文件名后缀，创建新的 File 对象
      if (_suggestedName) {
        file = new File([correctedFile], _suggestedName, { type: correctedFile.type || 'image/jpeg' });
      }
      
      try {
        let blob = await app.popup.clip({
          url: res.content,
          cut: {
            width: 400,
            height: 400,
          },
        });
        vant.Toast.loading({
          message: '上传中...',
          forbidClick: true,
          loadingType: 'spinner',
          overlay: true,
          duration: 0,
        });
        
        let ret = await xgjzt.oss.uploadFile({
          platform: 'h5',
          options: {
            content: blob,
            file: file,
            config: {
              image: {
                compress: false,
              },
            },
          },
        });
        this.changeParentInfos('photo', ret);
        vant.Toast.clear();
      } catch (error) {
        console.log('上传图片出错，请稍后重试。');
      }
    },
    changeParentInfos(prop, value) {
      let toast = this.$toast.loading({
        message: '加载中...',
        duration: 0,
        forbidClick: true,
      });
      let changeProps = {};
      changeProps[prop] = value;
      let newUserInfos = Object.assign({}, this.userInfo, changeProps);
      this.$api
        .parentUpdate(newUserInfos)
        .then(res => {
          toast.clear();
          if (res.code === 200) {
            this.updataUserInfo(newUserInfos);
          } else {
            this.$toast.fail(res.msg || '服务器出错，请稍后重试');
          }
        })
        .catch(err => {
          console.log('修改家长信息出错', err);
          this.infosChangeSubmiting = false;
        });
    },
    genderPickerConfirm(v) {
      this.genderPickerShow = false;
      this.changeParentInfos('sex', v.id);
    },
  },
  watch: {
    userInfo: {
      immediate: true,
      handler(v) {
        if (v.photo) {
          // this.$set(this.faceImgs, "0", v.photo);
          this.$set(this.faceImgs, '0', { isImage: true, ...v.photo }); // isImage: true兼容微信头像被识别成非图片
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.personal-info-page {
  color: var(--g8);
  .info-wrapper {
    font-size: var(--fs-md);
    background-color: var(--white);
    padding: 0 16px;
    .info-item {
      padding: 16px 0;
      min-height: 54px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .item-label {
        font-size: var(--fs-lg);
      }
      &:not(:last-child) {
        border-bottom: 0.5px solid var(--g3);
      }

      &.add-margin {
        margin-top: 24px;
      }
    }
    .user-photo {
      height: 48px;
      width: 48px;
      border-radius: 50%;
      background: #edf3f9;
      overflow: hidden;
    }
  }
  .item-right {
    text-align: right;
    color: var(--g6);
    display: flex;
    align-items: center;
    .item-icon {
      height: 16px;
      margin-left: 8px;
    }
  }
  .student-info {
    margin-top: 24px;
    background-color: var(--white);
    padding: 16px;
    min-height: 54px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .item-label {
      font-size: var(--fs-lg);
    }
  }
  .switch-user {
    margin-top: 24px;
    height: 52px;
    line-height: 52px;
    text-align: center;
    color: var(--g5);
    background-color: var(--white);
  }
}
</style>
<style lang="scss">
.personal-info-page {
  .info-wrapper {
    .user-photo .van-image,
    .user-photo .van-image > img,
    .user-photo .van-uploader__wrapper,
    .user-photo .van-uploader__upload {
      height: 48px;
      width: 48px;
      border-radius: 50%;
    }
    .user-photo .van-uploader__upload {
      margin: 0;
    }
    .user-photo .van-uploader__preview-delete {
      display: none;
    }
  }
}
</style>
